import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminLayout } from './admin/AdminLayout';
import { ProtectedRoute } from './admin/ProtectedRoute';
import { Spinner } from './components/Spinner';

const LoginPage = lazy(() => import('./admin/LoginPage').then((module) => ({ default: module.LoginPage })));
const UploadPage = lazy(() => import('./admin/UploadPage').then((module) => ({ default: module.UploadPage })));
const VideoDetailPage = lazy(() => import('./admin/VideoDetailPage').then((module) => ({ default: module.VideoDetailPage })));
const VideosPage = lazy(() => import('./admin/VideosPage').then((module) => ({ default: module.VideosPage })));
const PlayerPage = lazy(() => import('./player/PlayerPage').then((module) => ({ default: module.PlayerPage })));

export default function App() {
  return (
    <Suspense fallback={<main className="center-page"><Spinner label="Opening Logica Stream…" /></main>}><Routes>
      <Route path="/manage/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AdminLayout />}>
          <Route path="/manage/videos" element={<VideosPage />} />
          <Route path="/manage/videos/create" element={<UploadPage />} />
          <Route path="/manage/videos/:publicId" element={<VideoDetailPage />} />
        </Route>
      </Route>
      <Route path="/watch/:publicId" element={<PlayerPage />} />
      <Route path="/embed/:publicId" element={<PlayerPage />} />
      <Route path="/" element={<Navigate to="/manage/videos" replace />} />
      <Route path="*" element={<Navigate to="/manage/videos" replace />} />
    </Routes></Suspense>
  );
}
